import React, {Fragment} from "react";
import PageTitle from "../../../Layout/AppMain/PageTitle";
import Tabs from "react-responsive-tabs";
import {Button, Card, CardBody, CardTitle, Col, Row} from "reactstrap";
import privateActions from "../../../API/privateCalls/privateActions";
import TablaAlumnos from "../../Demografico/Alumnos/component/AlumnosList";

export default class Exportar extends React.Component {
    render() {
        return (
            <Fragment>
                <PageTitle
                    heading="Herramienta administrativa para exportar datos"
                    icon="pe-7s-config icon-gradient bg-mean-fruit"
                />
                <Row>
                    <Col md="12" lg="24">
                        <Card className="main-card mb-3">
                            <CardBody>
                                <CardTitle className="text-center">
                                    Usuarios
                                </CardTitle>
                                <Row>
                                    <Col lg="4">
                                        <Card className="main-card mb-3">
                                            <CardBody>
                                                <CardTitle className="text-center">
                                                    Usuarios
                                                </CardTitle>
                                                <Button color="info" className="btn-block mb-3" onClick={()=>privateActions.csvAlumnos()}>Exportar</Button>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg="4">
                                        <Card className="main-card mb-3">
                                            <CardBody>
                                                <CardTitle className="text-center">
                                                    Docentes
                                                </CardTitle>
                                                <Button color="info" className="btn-block mb-3" onClick={()=>privateActions.csvDocentes()}>Exportar</Button>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg="4">
                                        <Card className="main-card mb-3">
                                            <CardBody>
                                                <CardTitle className="text-center">
                                                    Familiares
                                                </CardTitle>
                                                <Button color="info" className="btn-block mb-3" onClick={()=>privateActions.csvFamiliares()}>Exportar</Button>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="6">
                        <Card className="main-card mb-3">
                            <CardBody>
                                <CardTitle className="text-center">
                                    Lugares
                                </CardTitle>
                                <Row>
                                    <Col lg="6">
                                        <Card className="main-card mb-3">
                                            <CardBody>
                                                <CardTitle className="text-center">
                                                    Escuelas
                                                </CardTitle>
                                                <Button color="info" className="btn-block mb-3" onClick={()=>privateActions.csvInstituciones()}>Exportar</Button>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg="6">
                                        <Card className="main-card mb-3">
                                            <CardBody>
                                                <CardTitle className="text-center">
                                                    Aulas
                                                </CardTitle>
                                                <Button color="info" className="btn-block mb-3" onClick={()=>privateActions.csvAulas()}>Exportar</Button>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md="12" lg="6">
                        <Card className="main-card mb-3">
                            <CardBody>
                                <CardTitle className="text-center">
                                    Vínculos
                                </CardTitle>
                                <Row>
                                    <Col lg="6">
                                        <Card className="main-card mb-3">
                                            <CardBody>
                                                <CardTitle className="text-center">
                                                    Alumnos de las Aulas
                                                </CardTitle>
                                                <Button color="info" className="btn-block mb-3" onClick={()=>privateActions.csvAlumnosAulas()}>Exportar</Button>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col>
                                        <Card className="main-card mb-3">
                                            <CardBody>
                                                <CardTitle className="text-center">
                                                    Docentes de las Escuelas
                                                </CardTitle>
                                                <Button color="info" className="btn-block mb-3" onClick={()=>privateActions.csvDocentesInstituciones()}>Exportar</Button>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="12">
                        <Card className="main-card mb-3">
                            <CardBody>
                                <CardTitle className="text-center">
                                    Objetivos del juego
                                </CardTitle>
                                <Row>
                                    <Col lg="3">
                                        <Card className="main-card mb-3">
                                            <CardBody>
                                                <CardTitle className="text-center">
                                                    Cordones de asteroides completados
                                                </CardTitle>
                                                <Button color="info" className="btn-block mb-3" onClick={()=>privateActions.csvActividadesCordonesDeAsteroides()}>Exportar</Button>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg="3">
                                        <Card className="main-card mb-3">
                                            <CardBody>
                                                <CardTitle className="text-center">
                                                    Planetas desbloqueados
                                                </CardTitle>
                                                <Button color="info" className="btn-block mb-3" onClick={()=>privateActions.csvActividadesPlanetasDesbloqueados()}>Exportar</Button>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg="3">
                                        <Card className="main-card mb-3">
                                            <CardBody>
                                                <CardTitle className="text-center">
                                                    Historias leídas
                                                </CardTitle>
                                                <Button color="info" className="btn-block mb-3" onClick={()=>privateActions.csvActividadesHistoriasLeidas()}>Exportar</Button>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg="3">
                                        <Card className="main-card mb-3">
                                            <CardBody>
                                                <CardTitle className="text-center">
                                                    Minijuegos
                                                </CardTitle>
                                                <Button color="info" className="btn-block mb-3" onClick={()=>privateActions.csvActividadesMinijuegosCompletados()}>Exportar</Button>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Fragment>
        );
    }
}


// WEBPACK FOOTER //
// src/Pages/Administracion/Exportar/index.js